export default __webpack_public_path__ + "static/media/codelogo.6c87e615.png";